import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';

export const BottomInfo = styled(FlexibleDiv)<{ $withMargin: boolean }>`
  flex-wrap: wrap;
  gap: 10px 0;

  ${({ $withMargin }) =>
    $withMargin &&
    css`
      margin-bottom: 20px;
    `}

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-bottom: 0;
  }
`;

export const InfoItem = styled(Typography)`
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Dot = styled.span`
  margin: 0 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: bold;
`;
